import { cva } from "class-variance-authority";

export const inputVariants = cva(
  "placeholder:opacity-muted border-border-base focus-visible:border-primary focus-visible:ring-focus focus-within:border-primary hover:border-primary disabled:opacity-disabled aria-invalid:ring-danger/40! aria-invalid:border-danger! h-9 w-full min-w-0 rounded-xl border bg-base-100 px-3 transition-[color,box-shadow] outline-none ring-[3px] ring-transparent disabled:pointer-events-none file:h-full file:cursor-pointer file:font-medium [&[type=file]]:cursor-pointer",
);
